<template>
  <div class="i-confirmation">
    <iBackground
      :background-image="bgSquiggleGreen"
      :color="white"
    />

    <div class="header">
      <div class="logo">
        <a @click="goToHome()"
          ><img
            :src="logo"
            alt="JobTest.org"
            class="logo-img"
          />
        </a>
      </div>
    </div>

    <div class="wrap">
      <div class="card">
        <div class="card-top">
          <img :src="iconCheckThankYou" />
          <span>Payment Confirmed</span>
        </div>

        <div class="card-bottom">
          <span class="card-bottom-text-large">You will be redirected in {{ data.countdown }} seconds</span>
          <span class="card-bottom-text-medium">Thank you for trusting us to help you on your career journey!</span>
        </div>
      </div>

      <div class="back-cta">
        <a
          class="back-link"
          @click="goToHome"
        >
          <img :src="iconChevron" /> Back to Jobtest Dashboard
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from "@/router"
import { onMounted, reactive } from "vue"

// HELPERS
import { GlobalVariables } from "@/helpers/globalVariables"

// COMPONENTS
import iBackground from "@/components/global/Background.vue"

// ASSETS
import iconCheckThankYou from "@/assets/icons/icon-check-thank-you.svg"
import iconChevron from "@/assets/icons/icon-chevron-left-blue.svg"
import bgSquiggleGreen from "@/assets/jobTest/bg-squiggle-green.svg"
import logo from "@/assets/logo/logo-dark.svg"

// STYLES
import { white } from "@/styles/colors"
import GtmService, { UserFlow } from "@/services/gtmService"

// DATA
const data = reactive({
  countdown: 5,
  oneSecondInMs: 1000
})

// FUNCTION
function goToHome() {
  router.push({ name: GlobalVariables.urls.coaching.children.home.routeName })
}

function startCountdown() {
  // Update the countdown every second
  let timer = setInterval(() => {
    if (data.countdown > 0) {
      data.countdown--
    } else {
      clearInterval(timer)
      goToHome()
    }
  }, data.oneSecondInMs)
}

async function reportOrderToGoogleTagManager() {
  const urlParams = new URLSearchParams(window.location.search)
  const sessionId = urlParams.get("session_id")
  const lastSessionId = localStorage.getItem("last-checkout-session-id")
  const valueAsString = urlParams.get("val")
  const value = valueAsString ? parseFloat(valueAsString) : 0

  if (!sessionId || sessionId == lastSessionId) return

  localStorage.setItem("last-checkout-session-id", sessionId)
  try {
    await GtmService.purchaseEvent(UserFlow.COACHING, sessionId, value)
  } catch (error) {
    console.error("Error reporting coaching purchase to Google Tag Manager", error)
  }
}
// LIFECYCLE HOOKS

onMounted(async () => {
  await reportOrderToGoogleTagManager()
  startCountdown()
})
</script>

<style scoped lang="scss">
.i-confirmation {
  @include flex($justify: center, $align: center);

  min-height: 100vh;

  .header {
    @include flex(row, $justify: space-between, $align: center);

    width: 100%;
    padding: 15px;
    position: fixed;
    top: 0;

    @media screen and (min-width: $breakpoint-sm) {
      padding: 15px 40px;
    }

    .logo {
      a:hover {
        cursor: pointer;
      }

      .logo-img {
        width: 160px;
      }
    }
  }

  .wrap {
    width: 90%;
    max-width: 500px;

    .card {
      background-color: rgb(244.37 244.37 244.37 / 60%);
      text-align: start;
      overflow: hidden;

      @include border-radius-lg;
      @include shadow;

      .card-top {
        @include flex($direction: column, $justify: center, $align: center, $gap: 16px);
        @include display-sm;

        background-color: $azure-radiance950;
        color: $white;
        font-weight: bold;
        text-align: center;
        padding: 40px 24px;
        background-image: url("@/assets/cards/bg-thank-you.svg"); /* Image URL */
        background-size: cover; /* Cover the entire div */
        background-position: center; /* Center the background image */
        background-repeat: no-repeat; /* Do not repeat the background image */

        @media screen and (min-width: $breakpoint-lg) {
          padding: 48px 32px;
        }

        img {
          width: 48px;
        }
      }

      .card-bottom {
        @include flex($direction: column, $justify: center, $align: center, $gap: 16px);

        padding: 24px;
        text-align: center;

        @media screen and (min-width: $breakpoint-lg) {
          padding: 32px 48px;
        }

        &-text-large {
          @include text-xl;

          font-weight: bold;
          max-width: 325px;
        }

        &-text-medium {
          @include text-lg;

          font-weight: medium;
          color: $comet600;
          max-width: 400px;
        }
      }
    }

    .back-cta {
      color: $azure-radiance950;
      text-align: center;
      margin-top: 70px;
      cursor: pointer;

      .back-link {
        @include text-link;

        text-decoration: none;
        border-bottom: 0;
        font-weight: normal;

        img {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
